import React, { useState, useEffect } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import {
  WhatsAppBusinessLogoIcon,
  HamburguerIcon,
  BrandIcon,
  StoreIcon,
  UserIcon,
  DashboardIcon
} from "components";

import "./sidebar.scss";

export const Sidebar = () => {
  const { path } = useRouteMatch();
  const [location, setLocation] = useState(path);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
   setIsAdmin(JSON.parse(localStorage.getItem("@sidebar")));
  },[])

  const menu = [
    {
      icon: <DashboardIcon />,
      link: "/dashboard",
      isActive: false,
      text: "Dashboard",
      restrict: false
    },
    {
      icon: <BrandIcon />,
      link: "/marcas",
      isActive: false,
      text: "Marcas",
      restrict: true
    },
    {
      icon: <UserIcon />,
      link: "/usuarios",
      isActive: false,
      text: "Usuários",
      restrict: true
    },
    {
      icon: <StoreIcon />,
      link: "/lojas",
      isActive: false,
      text: "Lojas",
      restrict: false
    }
  ];

  const getCurrentUrl = () => {
    setLocation(path);
  };

  const handleClickLink = () => {
    getCurrentUrl();
  };

  const getClassName = i => {
    return location === i.link
      ? "p-4 menu__link menu__link--is-active"
      : "p-4 menu__link";
  };

  const renderSideBarItem = (listItem, index) => {
    if (!listItem.restrict || isAdmin) {
      return (
        <li className="menu__item" key={index}>
          <Link
            to={listItem.link}
            onClick={() => handleClickLink()}
            className={getClassName(listItem)}>
            <i className="menu__icon">{listItem.icon}</i>
            <strong> {listItem.text} </strong>
          </Link>
        </li>
      )
    }
  }

  return (
    <aside className="sidebar">
      <div className="px-4 sidebar__header">
        <HamburguerIcon />
        <WhatsAppBusinessLogoIcon />
      </div>
      <div className="sidebar__body">
        <ul className="menu">
          {menu.map((i, index) => (
            renderSideBarItem(i, index)
          ))}
        </ul>
      </div>
    </aside>
  );
};
